<template>

  <div style="margin-left:24px;height: 103vh; width: 100%">
    <!-- <div style="height: 200px overflow: auto;">
      <p>First marker is placed at {{ withPopup.lat }}, {{ withPopup.lng }}</p>
      <p>Center is at {{ currentCenter }} and the zoom is: {{ currentZoom }}</p>
      <button @click="showLongText">
        Toggle long popup
      </button>
      <button @click="showMap = !showMap">
        Toggle map
      </button>
    </div> -->
    
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 80%"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >

      <l-tile-layer
        :url="url"
      />

      <l-marker  v-for="spaces in arrSpaces" :key="spaces.idSpace" :lat-lng="spaces.cordenadas2">
        <l-popup>
          <div >
            <p style="margin:0px;margin-bottom:0px; color:#777; font-size:18px;">{{spaces.name}}</p>
            <!-- <p v-show="showParagraph">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
              Donec finibus semper metus id malesuada.
            </p> -->
            <br><v-btn
              elevation="2"
              small
                  rounded
              depressed
              color="admiraGreen"
              dark
              @click="goSpace(spaces)"
            >Acceder</v-btn>   
          </div>
        </l-popup>
      </l-marker>

      <!-- <l-marker :lat-lng="withPopup">
        <l-popup>
          <div @click="innerClick">
            I am a popup
            <p v-show="showParagraph">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
              Donec finibus semper metus id malesuada.
            </p>
          </div>
        </l-popup>
      </l-marker>

      <l-marker :lat-lng="withPopup2">
        <l-popup>
          <div @click="innerClick">
            I am a popup
            <p v-show="showParagraph">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
              Donec finibus semper metus id malesuada.
            </p>
          </div>
        </l-popup>
      </l-marker> -->
      <!-- <l-marker :lat-lng="withTooltip">
        <l-tooltip :options="{ permanent: true, interactive: true }">
          <div @click="innerClick">
            I am a tooltip
            <p v-show="showParagraph">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
              Donec finibus semper metus id malesuada.
            </p>
          </div>
        </l-tooltip>
      </l-marker> -->
    </l-map>
  </div>
</template>

<script>
import { latLng, icon} from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LIcon } from "vue2-leaflet";
import { mapState, mapActions, mapMutations } from "vuex";


export default {
  name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LIcon
  },
  data() {
    return {
      zoom: 6,
      center: latLng(40.4167047, -3.7035825),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
     
    //   withPopup: {lat:41.3869846, lng:2.1678559},
    //         withPopup2: {lat:43.4280325, lng:-7.365351},

    //   withTooltip: latLng(40.4169019, -3.7056721),
      currentZoom: 6,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true,
      space: []
    };
  },
  computed: {
      ...mapState("queues", [
      "allSpaces",
    ]),
    arrSpaces(){
        
       this.allSpaces.forEach(element => {
            
           element.cordenadas2 = {lat: element.coordinates[0], lng:element.coordinates[1]}
            
       });
       return this.allSpaces
    }
  },
  methods: {
    ...mapMutations("queues", [
      
      "setActualSpaceMutation",
      
    ]),
    async goSpace(space){

      await this.setActualSpaceMutation(space);

      var mobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
        }
      };

      if(mobile.any() != null){
        this.$router.push({
          name: "ResumeSpaceMobile",
          params: { idQueue: space.idSpace }
        });
      }else{
        this.$router.push({
          name: "ResumeSpace",
          params: { idQueue: space.idSpace }
        });
      }

    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    }
  },
  created(){

  }
};
</script>


// WEBPACK FOOTER //
// src/components/SpacesMap.vue